'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  min-height: 30px;\n  min-width: 200px;\n'], ['\n  position: relative;\n  min-height: 30px;\n  min-width: 200px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-start;\n  border: 1px solid ', ';\n  padding: 4px 10px;\n  border-radius: 5px;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  border: 1px solid ', ';\n  padding: 4px 10px;\n  border-radius: 5px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  input {\n    border-radius: 0px;\n    width: 100%;\n    display: block;\n    border: none;\n    margin: 0px 10px;\n    height: 30px;\n    font-size: 15px;\n\n    :focus {\n      outline: none;\n    }\n  }\n'], ['\n  input {\n    border-radius: 0px;\n    width: 100%;\n    display: block;\n    border: none;\n    margin: 0px 10px;\n    height: 30px;\n    font-size: 15px;\n\n    :focus {\n      outline: none;\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 10px;\n  left: 20px;\n'], ['\n  position: absolute;\n  top: 10px;\n  left: 20px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 20px;\n  color: ', '\n'], ['\n  font-size: 20px;\n  color: ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 90%;\n  top: 35px;\n  border: 1px solid ', ';\n  z-index: 8000;\n  margin-left: 20px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);\n\n  a {\n    display: block;\n    background-color: ', ';\n    vertical-align: middle;\n    padding: 6px 12px;\n    cursor: pointer;\n    font-size: 14px;\n    color: ', ';\n    border-bottom: 1px solid ', ';\n    text-decoration: none;\n    text-align: left;\n    width: 100%;\n  }\n\n  a:hover {\n    background-color: ', ';\n  }\n'], ['\n  position: absolute;\n  width: 90%;\n  top: 35px;\n  border: 1px solid ', ';\n  z-index: 8000;\n  margin-left: 20px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);\n\n  a {\n    display: block;\n    background-color: ', ';\n    vertical-align: middle;\n    padding: 6px 12px;\n    cursor: pointer;\n    font-size: 14px;\n    color: ', ';\n    border-bottom: 1px solid ', ';\n    text-decoration: none;\n    text-align: left;\n    width: 100%;\n  }\n\n  a:hover {\n    background-color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('./../utils');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _MozartTextBox = require('./../MozartTextBox');

var _MozartTextBox2 = _interopRequireDefault(_MozartTextBox);

var _MozartModal = require('../MozartDialog/MozartModal');

var _MozartModal2 = _interopRequireDefault(_MozartModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var InputContainer = _styledComponents2.default.div(_templateObject2, _color2.default.blue_accent);

var Input = _styledComponents2.default.div(_templateObject3);

var CurrentSelected = _styledComponents2.default.span(_templateObject4);

var Icon = _styledComponents2.default.div(_templateObject5, _color2.default.blue_accent);

var ResultContainer = _styledComponents2.default.div(_templateObject6, _color2.default.purple_main, _color2.default.purple_accent, _color2.default.blue_main, _color2.default.purple_main, _color2.default.purple_main);

var MozartAutoComplete = function (_Component) {
  _inherits(MozartAutoComplete, _Component);

  function MozartAutoComplete(props) {
    _classCallCheck(this, MozartAutoComplete);

    var _this = _possibleConstructorReturn(this, (MozartAutoComplete.__proto__ || Object.getPrototypeOf(MozartAutoComplete)).call(this, props));

    _this.state = {
      selected: _this.props.defaultData,
      results: [],
      open: false,
      comment_text: ''
    };

    _this.handleChangeDebounce = (0, _utils.debounce)(_this.handleChangeDebounce.bind(_this), 600);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  _createClass(MozartAutoComplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside, true);
      this.loadCurrSelected();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, true);
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      var domNode = _reactDom2.default.findDOMNode(this);
      if (!domNode || !domNode.contains(event.target)) {
        this.resetResultDropDown();
      }
    }
  }, {
    key: 'check',
    value: function check(value, checkValue) {
      return value.toLowerCase().indexOf(checkValue.toLowerCase()) !== -1;
    }
  }, {
    key: 'getDropDownData',
    value: function getDropDownData(data, value) {
      var _this2 = this;

      var maxSearchResults = this.props.maxSearchResults;

      return data.filter(function (item) {
        return _this2.check(item.name, value);
      }).slice(0, maxSearchResults);
    }
  }, {
    key: 'getDropDownElem',
    value: function getDropDownElem(item) {
      var includeComment = this.props.includeComment;

      return _react2.default.createElement(
        'a',
        { onClick: includeComment ? this.openModal.bind(this, item) : this.onSelect.bind(this, item) },
        item.name
      );
    }
  }, {
    key: 'getDropDownElems',
    value: function getDropDownElems(data, value) {
      var items = this.getDropDownData(data, value);
      return value.trim().length > 0 ? items.slice(0, 10).map(this.getDropDownElem.bind(this)) : [];
    }
  }, {
    key: 'getModal',
    value: function getModal() {
      var testId = this.props.testId;

      return _react2.default.createElement(
        _MozartModal2.default,
        {
          show: this.state.open,
          onClose: this.closeModal.bind(this),
          title: 'Reason',
          id: testId,
          disableSubmit: this.state.comment_text.length < 4,
          submitLabel: 'Submit',
          handleSubmit: this.onSelect.bind(this, this.state.open) },
        _react2.default.createElement(_MozartTextBox2.default, {
          ref: 'comment_textarea',
          key: 'comment_textarea',
          hintText: 'At least 4 characters...',
          onChange: this.onChangeCommentText.bind(this),
          className: 'comment_textarea',
          name: 'comment',
          multiLine: true,
          minChars: 3
        })
      );
    }
  }, {
    key: 'onChangeCommentText',
    value: function onChangeCommentText(value) {
      this.setState({
        comment_text: value
      });
    }
  }, {
    key: 'loadCurrSelected',
    value: function loadCurrSelected() {
      var _this3 = this;

      var curr = this.state.selected;
      _reactDom2.default.findDOMNode(this.refs.autocomplete_input).value = curr ? curr.name : '';
      if (_reactDom2.default.findDOMNode(this.refs.result) !== null) {
        setTimeout(function () {
          _reactDom2.default.findDOMNode(_this3.refs.result).style.display = 'none';
        }, 1000);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      event.persist();
      this.handleChangeDebounce(event);
    }
  }, {
    key: 'handleChangeDebounce',
    value: function handleChangeDebounce(event) {
      var data = this.props.data;

      this.setState({
        results: this.getDropDownElems(data, event.target.value)
      });
    }
  }, {
    key: 'resetResultDropDown',
    value: function resetResultDropDown() {
      this.setState({ results: [] });
    }
  }, {
    key: 'openModal',
    value: function openModal(item) {
      this.setState({ open: item });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({ open: false, results: [] });
    }
  }, {
    key: 'onSelect',
    value: function onSelect(item) {
      var _this4 = this;

      this.setState({ selected: item, open: false }, function () {
        if (_this4.props.onSelect) {
          _this4.props.onSelect(item, _this4.state.comment_text);
        }
        _this4.loadCurrSelected();
        _this4.resetResultDropDown();
      });
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      _reactDom2.default.findDOMNode(this.refs.autocomplete_input).value = '';
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.loadCurrSelected();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          showIcon = _props.showIcon,
          disabled = _props.disabled,
          includeComment = _props.includeComment,
          hintText = _props.hintText,
          themeId = _props.themeId;

      return _react2.default.createElement(
        Container,
        { 'data-qa': this.props.testId, style: style, ref: this.setWrapperRef, 'data-theme': themeId },
        _react2.default.createElement(
          InputContainer,
          null,
          showIcon && _react2.default.createElement(
            Icon,
            null,
            _react2.default.createElement('span', { className: 'icon-Edit' })
          ),
          _react2.default.createElement(
            Input,
            null,
            _react2.default.createElement('input', {
              ref: 'autocomplete_input',
              style: this.state.open && this.state.open.name ? { color: '#FFF' } : {},
              disabled: disabled,
              placeholder: this.state.open && this.state.open.name ? '' : hintText,
              onChange: !disabled ? this.handleChange.bind(this) : undefined,
              onFocus: !disabled ? this.onFocus.bind(this) : undefined,
              onBlur: !disabled ? this.onBlur.bind(this) : undefined
            }),
            this.state.open && _react2.default.createElement(
              CurrentSelected,
              null,
              this.state.open.name
            )
          )
        ),
        this.state.results.length > 0 && _react2.default.createElement(
          ResultContainer,
          { ref: 'result' },
          this.state.results
        ),
        includeComment && this.getModal()
      );
    }
  }]);

  return MozartAutoComplete;
}(_react.Component);

MozartAutoComplete.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** callback when select */
  onSelect: _propTypes2.default.func,
  /** if true open the dialog comment */
  includeComment: _propTypes2.default.bool,
  /** if true disable selection */
  disabled: _propTypes2.default.bool,
  /** if none selected hint text show up */
  hintText: _propTypes2.default.string,
  /** default data {id name img } */
  defaultData: _propTypes2.default.object,
  /** data array of object {id, name} */
  data: _propTypes2.default.array,
  /** if true show the edit icon in front of the text */
  showIcon: _propTypes2.default.bool,
  /** maximum items for dropdown autocomplete */
  maxSearchResults: _propTypes2.default.number
};
MozartAutoComplete.defaultProps = {
  showIcon: false,
  hintText: 'Type To Search',
  maxSearchResults: 10,
  data: [],
  includeComment: true,
  disabled: false,
  testId: 'MozartAutoComplete',
  themeId: 'MozartAutoComplete'
};
exports.default = MozartAutoComplete;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartAutoComplete/MozartAutoComplete.js
// module id = 1957
// module chunks = 1